import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';

import { EuiFileUploadComponent } from './eui-file-upload.component';
import { EuiFileUploadProgressComponent } from './progress/eui-file-upload-progress.component';
import { EuiFilePreviewComponent } from './file-preview/file-preview.component';
import { EuiFileSizePipe } from './pipes/filesize.pipe';
import { EuiButtonModule } from '../eui-button';
import { EuiIconColorModule, EuiIconModule } from '../atoms';
import { EuiFileUploadUtilsService } from './utils/eui-file-upload.utils';
import { EuiUploadedFileComponent } from './uploaded-file/uploaded-file.component';

@NgModule({
    imports: [
        CommonModule,
        MatProgressBarModule,
        EuiButtonModule,
        EuiIconModule,
        TranslateModule,
        EuiIconColorModule,
    ],
    declarations: [
        EuiFileUploadComponent,
        EuiFileUploadProgressComponent,
        EuiFilePreviewComponent,
        EuiFileSizePipe,
        EuiUploadedFileComponent,
    ],
    providers: [
        EuiFileUploadUtilsService,
    ],
    exports: [
        EuiFileUploadComponent,
    ],
})
export class EuiFileUploadModule { }
